var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.students,"hide-default-footer":true,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('details-students',{attrs:{"id":item.actions.id,"type-student":"tutor"}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }